module.exports = __webpack_public_path__ + "img/tpc-39.535c9a64.jpg";